import { Language } from "./language";

export class Languages{
    
    data: Array<Language>;

    constructor(){
        this.data = [
            {name:'Español', code:'es'}, 
            {name:'Inglés', code:'en'}
        ];
    }
}